export default class Settings {
    public settings = {
        host: location.host.indexOf('influtool.com') >= 0 ? 'https://api.pl.influtool.com/' : 'http://www2.api.influtool.com/'
    };

}
